import * as consts from './MapConsts';
import { geocoderRequest } from '../helpers/requestUtils';


export const geocoder = () => {
    return (dispatch, getState) => {
        const address = getState().property.info.address.full;

        dispatch({
            type: consts.GET_COORDINATES_PENDING
        });
        
        geocoderRequest(address).then(data => {
            dispatch({
                type: consts.GET_COORDINATES_FULFILLED,
                payload: {
                    location: {
                        lat: data.lat(),
                        lon: data.lng()
                    },
                    geocoderDataFullfilled: true
                }
            });
        }, error => {
            dispatch({
                type: consts.GET_COORDINATES_REJECTED,
                payload: {
                    geocoderDataFullfilled: true,
                    geocoderError: error.errorMessage
                }
            });
        });
    }
}

